<script setup lang="ts">
import type { PropType } from 'vue';
import { useRoute } from 'vue-router';

import { accountService } from '@exchange/libs/account/service/src';
import ProfileUserSection from '@exchange/libs/account/ui/src/libs/ProfileUserSection.vue';

import type { NavigationLink } from './app-header/useNavigationLink';

defineProps({
  links: { type: Object as PropType<{ primary: Array<NavigationLink>; secondary: Array<NavigationLink> }>, required: true },
});

const route = useRoute();

const { userName, userEmail, accountIdHolder } = accountService;

const isPrimaryLinkActive = (link: NavigationLink) => {
  if (!route.name || typeof route.name !== 'string') {
    return false;
  }

  const ok = route.name === link.route?.name;
  const getMainName = (name?: string) => name?.split('.')[0] || '';
  const alsoOk = getMainName(route.name) === getMainName(link.route?.name);

  return ok || alsoOk;
};
</script>

<template>
  <div class="internal-navigation">
    <profile-user-section
      :with-secondary-info="true"
      :user-email="userEmail"
      :account-holder-id="accountIdHolder"
      :user-name="userName"
    />
    <div class="internal-navigation__links-section">
      <div class="internal-navigation__links internal-navigation__links--primary">
        <x-list-item
          v-for="link in links.primary"
          :key="link.id"
          :active="isPrimaryLinkActive(link)"
          :left-icon-inherit-stroke="true"
          :left-icon-name="link.icon"
          :left-icon-warning="link.iconWithWarning"
          :left-icon-info="link.iconWithInfo"
          :title="link.title"
          :router-link="link.route"
        />
      </div>
      <div class="internal-navigation__links internal-navigation__links--secondary">
        <x-list-item
          v-for="link in links.secondary"
          :key="link.id"
          :left-icon-inherit-stroke="true"
          :left-icon-name="link.icon"
          :title="link.title"
          :href="link.url"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.internal-navigation {
  &__links {
    --ot-list-item-active-bg-custom: rgb(var(--v-theme-elevation-1));

    padding: 24px 0;
    border-bottom: 1px solid rgb(var(--v-theme-elevation-2));

    &:last-child {
      border-style: none;
    }
  }
}
</style>
